import {
  PRESUPUESTADOR_SEND_EMAIL_BEGIN,
  PRESUPUESTADOR_SEND_EMAIL_SUCCESS,
  PRESUPUESTADOR_SEND_EMAIL_FAILURE,
  PRESUPUESTADOR_SEND_EMAIL_DISMISS_ERROR,
} from './constants'
import axios from 'axios'
import { PRESUPUESTADOR_ENDPOINT } from 'cfgCommon/endpoints'

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function sendEmail(id_presupuesto) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: PRESUPUESTADOR_SEND_EMAIL_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {

      const doRequest = axios.get(PRESUPUESTADOR_ENDPOINT+`/${id_presupuesto}/mail`)
      doRequest.then(
        (res) => {
          dispatch({
            type: PRESUPUESTADOR_SEND_EMAIL_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: PRESUPUESTADOR_SEND_EMAIL_FAILURE,
            data: { error: err.message },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissSendEmailError() {
  return {
    type: PRESUPUESTADOR_SEND_EMAIL_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PRESUPUESTADOR_SEND_EMAIL_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        sendEmailPending: true,
        sendEmailError: null,
      };

    case PRESUPUESTADOR_SEND_EMAIL_SUCCESS:
      // The request is success
      return {
        ...state,
        sendEmailPending: false,
        sendEmailError: null,
      };

    case PRESUPUESTADOR_SEND_EMAIL_FAILURE:
      // The request is failed
      return {
        ...state,
        sendEmailPending: false,
        sendEmailError: action.data.error,
      };

    case PRESUPUESTADOR_SEND_EMAIL_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        sendEmailError: null,
      };

    default:
      return state;
  }
}
